import React from 'react'
import PropTypes from 'prop-types'

export default class PreviewHeader extends React.Component {

  static propTypes = {
    billEditor: PropTypes.object.isRequired
  }

  render() {
    if (!this.props.billEditor.getNotes()) {
      return null
    }
    return (
      <div style={styles.container}>
        <div style={styles.darkLabel}>NOTES</div>
        <div style={styles.grayLabel}>{ this.props.billEditor.getNotes() }</div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 32,
    paddingRight: 32,
    paddingBottom: 48
  },
  darkLabel: {
    fontSize: 14,
    color: '#1f2229',
    marginBottom: 22
  },
  grayLabel: {
    fontSize: 14,
    color: '#828691'
  }
}



// WEBPACK FOOTER //
// ./src/billing/common/modules/notes/NotesPreview.js